import fetch from "auth/FetchInterceptor";
import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";

const myOrderService = {};

myOrderService.getOrder = ({ orderId }) => {
  return fetchV2({
    url: `${env.API_MSP}/my-orders/${orderId}`,
    method: "get",
    params: {
      expand: "mainNote",
    },
  });
};

//Cancel order
myOrderService.cancelOrder = ({
  orderId = undefined,
  order_code,
  reason_note,
  reason_id,
}) => {
  return fetch({
    url: `${env.API_MSP}/my-orders/${orderId}/cancel`,
    method: "post",
    data: {
      order_code,
      reason_note,
      reason_id,
    },
  });
};

// create order
myOrderService.createOrder = data => {
  return fetch({
    url: `${env.API_MSP}/my-orders`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Detail Customer Location By Order
myOrderService.detailCustomerLocationByOrder = ({ id_order = undefined }) => {
  return fetchV2({
    url: `${env.API_MSP}/ajax/get-customer-location-by-order`,
    method: "post",
    data: {
      id_order,
    },
  });
};

export default myOrderService;
